import { IExperiment } from '../api/experiments';

/**
 * Домены на которых будет работать эксперимент с микроразметкой
 */
export const ALLOW_SUBDOMAINS_MICRODATA = ['korolev', 'lyubertsy'];
/**
 * Название эксперимента с микроразметкой
 */
export const MICRODATA_EXPERIMENT = 'microdata_experiment';

export enum EMicrodataExperimentGroups {
  B = 1,
}

export function getHittingMicrodataExperiment(experiments: IExperiment[]): boolean {
  const microdataExperiment = experiments.find(experiment => experiment.name === MICRODATA_EXPERIMENT);

  return Boolean(microdataExperiment && microdataExperiment.abGroup === EMicrodataExperimentGroups.B);
}
